import { HistoryResponse } from 'app/model/history-response';

interface HistoryInstance<T> {
    id: number;
    entityId: string;
    eventDate: string;
    object: T;
}

export class HistoryReconstructor<T> {
    private latestModelVersion = new Map<string, T>();
    private index = 0;
    public processRecord(auditData: HistoryResponse): HistoryInstance<T> {
        const object = (this.latestModelVersion.get(auditData.entityId) ?? {}) as T;

        auditData.changes.forEach((change) => {
            (object as Record<string, string>)[change.field] = change.newValue.userValue;
        });

        this.latestModelVersion.set(auditData.entityId, object);

        return {
            id: this.index++,
            entityId: auditData.entityId,
            eventDate: auditData.date,
            object,
        };
    }
}
